module.exports = __webpack_public_path__ + "img/6d9338aa2b951efd9df2cadf4bf65696.png";